import { ActionTypes } from 'modules/experiments/ducks/actionTypes';
import { ExperimentsTableData, ExperimentsTableQuery } from 'modules/experiments/types';

export const fetchExperimentsTableDataRequest = (queryData: ExperimentsTableQuery) => ({
  type: ActionTypes.FETCH_TABLE_DATA_REQUEST,
  queryData,
});

export const fetchExperimentsTableDataResponse = (data: ExperimentsTableData) => ({
  type: ActionTypes.FETCH_TABLE_DATA_RESPONSE,
  payload: data,
});

export const fetchExperimentsTableDataError = () => ({
  type: ActionTypes.FETCH_TABLE_DATA_ERROR,
});
